<template>
  <el-container>
    <!-- <el-aside width="50px"></el-aside> -->
    <el-container >
      <el-header>
        <el-menu
          router
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          :ellipsis="false"
        >
          <el-menu-item index="/">51卷尺</el-menu-item>
          <div class="flex-grow" />
          <template v-for="(item, index) in menuList">
            <template v-if="!item.children">
              <el-menu-item
                :index="item.key"
                :key="item.key"
                :default-active="$route.Home"
              >
                {{ item.label }}</el-menu-item
              >
            </template>
            <template v-else>
              <el-sub-menu :index="item.key" :key="item.label">
                <template #title>{{ item.label }}</template>
                <template
                  v-for="(itemChild, i) in item.children"
                  :key="itemChild.meterKey"
                >
                  <el-menu-item
                    v-if="!itemChild.children"
                    :index="itemChild.meterKey+item.key"
                    :key="itemChild.meterKey+item.key"
                    :route="{
                      path: itemChild.key,
                      query: {
                        id: itemChild.meterKey,
                        name: itemChild.label,
                        introduce: itemChild.introduce,
                      },
                    }"
                    >{{ itemChild.label }}</el-menu-item
                  >
                  <template v-else>
                    <el-sub-menu
                      :index="itemChild.label+item.key"
                      :key="itemChild.label+item.key"
                    >
                      <template #title>{{ itemChild.label }}</template>
                      <el-menu-item
                        v-for="(iteChild, i) in itemChild.children"
                        :index="iteChild.label+item.key"
                        :key="iteChild.label+item.key"
                        :route="{
                          path: iteChild.key,
                          query: {
                            id: iteChild.meterKey,
                            name: iteChild.label,
                            introduce: iteChild.introduce,
                          },
                        }"
                        >{{ iteChild.label }}</el-menu-item
                      >
                    </el-sub-menu>
                  </template>
                </template>
              </el-sub-menu>
            </template>
          </template>
        </el-menu>
      </el-header>
      <el-main><el-container ><el-aside width="50px"></el-aside><router-view /><el-aside width="50px"></el-aside></el-container></el-main>
      <el-footer class="footer">
        <el-row>
          <el-col :span="6">
            <a
              href="https://shop471316383.taobao.com/shop/view_shop.htm"
              target="_blank"
              >店铺：51卷尺</a
            >
          </el-col>
          <el-col :span="6">
            <span>手机:13937009766</span>
          </el-col>
          <el-col :span="6">
            <span>邮箱:juanchi51@126.com</span>
          </el-col>
          <el-col :span="6">
            <span>QQ:775021044</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <a href="http://www.beian.miit.gov.cn/">豫ICP备19022049号</a
            >&nbsp;&nbsp;<a href="http://www.51juanchi.com/"
              >Copyright&nbsp;&nbsp;&copy&nbsp;&nbsp;51juanchi.com&nbsp;&nbsp;版权所有</a
            >
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
    <div id="kefu">
      <a :href="taobaoShop" target="_blank"
        ><label class="topD" title="网上店铺：51卷尺">网店</label></a
      >
      <a href="http://www.51juanchi.com" target="_blank"
        ><label class="topQQ" title="QQ:775021044">QQ</label></a
      >
    </div>
    <!-- <el-aside width="50px">
    </el-aside> -->
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      menuList: menuList,
      activeIndex: "Home",
      taobaoShop:taobaoShop
    };
  },
  mounted() {
    // console.log(menuList);
  },
};
</script>
<style lang="less">
#kefu {
  position: fixed;
  right: 10px;
  top: 30%;
  z-index: 999;
  width: 60px;
  height: 60px;
}
#kefu .topD,
#kefu .topQQ {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
  background-color: skyblue;
  border: none;
  color: white;
  text-align: center;
  line-height: 40px;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  transition-duration: 0.4s;
  -webkit-transition-duration: 0.4s;
}
#kefu .topQQ {
  top: 60px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background: linear-gradient(to bottom, #fcfcfc, #f1f1d8);
}

.el-footer {
  a,
  span {
    font-weight: bold;
    color: #c2bfbf;
  }
}
.flex-grow {
  flex-grow: 1;
}
a {
  text-decoration: none;
} //这个是设置a标签的默认状态去除下划线
a:visited {
  text-decoration: none;
} //这个是设置a标签的访问过后的状态去除下划线
a:hover {
  text-decoration: none;
} //这个是设置a标签的鼠标覆盖状态去除下划线
a:active {
  text-decoration: none;
} //这个是设置a标签的活跃状态去除下划线
.cir {
  border-radius: 50%;
  height: 25px;
  width: 25px;
}
.footer{
  background-color: #545c64;
  padding-top: 10px !important;
}
</style>
